// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"Kh","trustedRetailerTooltipWrapper":"Lh"};